import { educatorOnboardingTypes } from '../constants';

const initialState = {
  status: -1,
  data: {},
  responses: {},
  canReApply: false,
  submissionDate: '',
  roomUID: '',
  coveredState: {
    step: -1,
    subStep: -1
  },
  viewState: {
    step: -1,
    subStep: -1
  }
};

const setStatus = (state, { result }) => {
  const {
    status,
    submitted_at,
    form_uid,
    reasons,
    message,
    latest_rejected_video_submissions,
    last_question_after_demo_rejection
  } = result;
  return {
    ...state,
    status,
    submissionDate: submitted_at || '',
    formUID: form_uid,
    reasons,
    message,
    rejectedVideoSubmission:
      latest_rejected_video_submissions[0]?.answers?.[0] || {},
    lastQuestionAfterDemoRejection: last_question_after_demo_rejection
  };
};

const setCoveredState = (state, { data }) => {
  const { step, subStep } = data;
  return {
    ...state,
    coveredState: {
      step,
      subStep
    }
  };
};

const setViewState = (state, { data }) => ({
  ...state,
  viewState: {
    step: data.step,
    subStep: data.subStep
  }
});

const getFormDetails = (state, { result }) => ({
  ...state,
  data: result
});

const updateUserResponses = (state, responses) => {
  const responsesObj = responses.reduce(
    (map, question) => ({ ...map, [question.question_uid]: question.answers }),
    {}
  );
  const clxObject = responses.find(
    (response) => response?.answers?.[0]?.object_uid
  )?.answers?.[0];
  return {
    ...state,
    objectUID: clxObject?.object_uid || state.objectUID,
    objectType: clxObject?.object_type || state.objectType,
    responses: {
      ...state.responses,
      ...responsesObj
    }
  };
};

const updateStatus = (state, { status }) => ({
  ...state,
  status
});

const getUserResponses = (state, { result }) =>
  updateUserResponses(state, result);

const submitUserResponses = (state, { responses }) =>
  updateUserResponses(state, responses);

const getRoomUID = (state, { result }) => ({
  ...state,
  roomUID: result.my_latest_session?.uid ?? '',
  demoVideoState: result.my_latest_session?.state
});

const reducerMap = {
  [educatorOnboardingTypes.SET_EDU_ONBOARD_FORM_COVERED_STATE]: setCoveredState,
  [educatorOnboardingTypes.SET_EDU_ONBOARD_FORM_VIEW_STATE]: setViewState,
  [`${educatorOnboardingTypes.GET_EDU_ONBOARD_FORM_STATUS}_SUCCESS`]: setStatus,
  [`${educatorOnboardingTypes.GET_EDU_ONBOARD_FORM_DETAILS}_SUCCESS`]: getFormDetails,
  [`${educatorOnboardingTypes.GET_EDU_ONBOARD_FORM_USER_RESPONSE}_SUCCESS`]: getUserResponses,
  [`${educatorOnboardingTypes.SUBMIT_EDU_ONBOARD_FORM_USER_RESPONSE}_SUCCESS`]: submitUserResponses,
  [`${educatorOnboardingTypes.GET_LATEST_RECORDING_DETAILS}_SUCCESS`]: getRoomUID,
  [educatorOnboardingTypes.SET_EDU_ONBOARD_FORM_STATUS]: updateStatus
};

const reducer = (state = initialState, action) => {
  const actionHandler = reducerMap[action.type];
  const type = action.type.split('_');
  const actionType = type[type.length - 1];
  // last param is the isLoading state variable
  return actionHandler
    ? actionHandler(state, action, actionType === 'REQUEST')
    : state;
};

export default reducer;
